/** @format */

import {Trans} from 'react-i18next';

import {useNavigate} from 'react-router-dom';

import {Button} from './styles';

const BackToProjectButton = () => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/home/main/status');
  };

  return (
    <Button onClick={handleButtonClick}>
      <Trans>На страницу проекта</Trans>
    </Button>
  );
};

export default BackToProjectButton;
